import React, { Fragment, useEffect } from "react";
import Select, { components as SelectComponents } from "react-select";

import InputError from "@/components/UI/InputError";
import { providerRequests } from "@/api/(requests)/provider";
import { SectionCardWrapper } from "@/components/SectionCardWrapper";
import { testLocator } from "@/lib/helpers/test-locator";

export function NotesDiagnosis(props) {
  const { editable, editHandler, errors, note, profileView } = props;

  let numDiagnosis = 2;
  const [icdDataset, setIcdDataset] = React.useState([]);

  useEffect(() => {
    async function fetchICDDataset() {
      if (editable) {
        let dataset = await providerRequests.fetch_ICD10_dataset();

        setIcdDataset(dataset);
      }
    }

    fetchICDDataset();
  }, []);

  const handleSelection = (index, selectedOptions) => {
    if (!editable) {
      return;
    }

    editHandler(`ICD_10_axis_${index}_diagnosis`, selectedOptions, false);
  };

  let innerContent = (
    <>
      <div>
        <div className="clr-sec px-1 py-2 tw:font-bold">Diagnosis</div>
      </div>

      <div className={editable ? "px-1 row" : "px-1"}>
        {Array(numDiagnosis)
          .fill()
          .map((_, index) => {
            let diagnosisIndex = `${index + 1}`;

            if (editable) {
              let filteredOptions = icdDataset.filter((type) => type.axis === diagnosisIndex);

              let axisLabel = <span>ICD-10 Primary Diagnosis</span>;

              if (diagnosisIndex === "2") {
                axisLabel = <span>ICD-10 Secondary Diagnosis</span>;
              }

              return (
                <Fragment key={diagnosisIndex}>
                  <div
                    className="col-lg-6 col-12"
                    {...testLocator(
                      diagnosisIndex === "1"
                        ? "primaryDiagnosisSelect"
                        : "secondaryDiagnosisSelect",
                    )}
                  >
                    {axisLabel}
                    <Select
                      className="basic-multi-select"
                      classNamePrefix="select"
                      components={{
                        ClearIndicator: null,
                        Option: ({ children, innerProps, ...props }) => (
                          <SelectComponents.Option
                            {...props}
                            innerProps={{ ...innerProps, ...testLocator("diagnosisOption") }}
                          >
                            {children}
                          </SelectComponents.Option>
                        ),
                      }}
                      defaultValue={note[`ICD_10_axis_${diagnosisIndex}_diagnosis`]}
                      id={`diagnosisSelect${diagnosisIndex}`}
                      isMulti
                      onChange={(selectedOptions) =>
                        handleSelection(diagnosisIndex, selectedOptions)
                      }
                      options={filteredOptions}
                    />

                    {errors[`ICD_10_axis_${diagnosisIndex}_diagnosis`] ? (
                      <InputError
                        classes="custom-error"
                        testId={diagnosisIndex === "1" ? "primaryDiagnosisError" : undefined}
                      >
                        {errors[`ICD_10_axis_${diagnosisIndex}_diagnosis`]}
                      </InputError>
                    ) : (
                      ""
                    )}
                  </div>
                </Fragment>
              );
            } else {
              return (
                <Fragment key={diagnosisIndex}>
                  <div className="d-flex flex-column fs-12">
                    <ul>
                      {note[`ICD_10_axis_${diagnosisIndex}_diagnosis`] &&
                        note[`ICD_10_axis_${diagnosisIndex}_diagnosis`].map((icd_10, icdIndex) => {
                          return (
                            <div key={icd_10.code + icdIndex}>
                              {icd_10["code"] + " - " + icd_10["text"]}
                            </div>
                          );
                        })}
                    </ul>
                  </div>
                </Fragment>
              );
            }
          })}
      </div>
    </>
  );

  let content = (
    <SectionCardWrapper
      cardProps={{ className: "mx-0 px-3 py-3 max-width", style: { minHeight: 200 } }}
      plainProps={{ className: "border-top-note border-right-note", style: { minHeight: 150 } }}
      profileView={profileView}
    >
      {innerContent}
    </SectionCardWrapper>
  );

  return <>{content}</>;
}
